import type React from "react";
import { useState } from "react";
import { AuthProvider } from "./AuthContext";
import { ConsentBanner } from "./ConsentBanner";
import { Footer } from "./Footer";
import { LoginModal } from "./LoginModal";
import { Navbar } from "./Navbar";
import { SecretEntrance } from "./SecretEntrance";
import { ToastProvider } from "./Toast";

interface LayoutProps {
	children: React.ReactNode;
	currentApp: "portfolio" | "blogs" | "notes" | "resume";
	navLinks?: Array<{
		label: string;
		href: string;
		active?: boolean;
		onClick?: (e: React.MouseEvent) => void;
	}>;
	hideFooter?: boolean;
	isPublicRoute?: boolean;
}

const LayoutContent = ({
	children,
	currentApp,
	navLinks,
	hideFooter = false,
}: LayoutProps) => {
	const [isLoginOpen, setIsLoginOpen] = useState(false);

	return (
		<>
			<Navbar currentApp={currentApp} links={navLinks} />
			<main className="content-area">{children}</main>
			{!hideFooter && <Footer />}
			<LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
			<SecretEntrance onClick={() => setIsLoginOpen(true)} />
			<ConsentBanner />
		</>
	);
};

export const Layout = (props: LayoutProps) => {
	return (
		<ToastProvider>
			<AuthProvider>
				<LayoutContent {...props} />
			</AuthProvider>
		</ToastProvider>
	);
};
